<template>
  <div
    :class="{'custom-input --horizontal': isHorizontal}"
    class="custom-input"
  >
    <label v-if="label">{{ label }}</label>
    <div>
      <div>
        <textarea
          :type="type"
          :placeholder="placeholder"
          :class="{inactive: !active, 'custom-input__alert': alert}"
          v-model="inputValue"
          @blur="handleBlur"
          @focus="handleFocus()"
          @keyup.stop="handleUserInput"
        />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomSharedArea',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Boolean,
      default: false,
    },
    list: {
      type: String,
      default: '',
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: '',
      itemToEmit: {
        name: null,
        value: null,
      },
    }
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.inputValue = val
    },
  },
  mounted() {
    this.inputValue = this.value
  },
  methods: {
    clickOnSvg() {
      this.$emit('click-on-svg', true)
    },
    handleFocus() {
      this.$emit('focus', true)
    },
    handleUserInput() {
      this.itemToEmit.name = this.list
      this.itemToEmit.value = this.inputValue
      return this.list
        ? this.$emit('fill-input', this.itemToEmit)
        : this.$emit('fill-input', this.inputValue)
    },
    handleBlur() {
      this.$emit('blur', this.inputValue)
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.custom-input {
  @include shared-svg-inputs;

  align-items: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;

  &.--horizontal {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
  }

  /* .inscription & {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 25px 0;
  } */
  &__clickable {
    cursor: pointer;
  }

  &__alert {
    @include alert;
  }

  div {
    display: flex;
    flex: 1;
    flex-direction: column;

    div {
      display: flex;
      flex: 1;
      flex-direction: column;
    }
  }

  .error {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    text-align: left;
    width: 100%;

    span {
      @include errorInputs;
    }
  }
}

label {
  @include labels;

  /* .inscription & {
    margin: 0px;
  } */
  .custom-input.--horizontal & {
    flex: 1;
  }
}

textarea {
  @include sharable-input;

  display: flex;
  flex: 1;
  height: 100%;
  margin-bottom: 10px;
  min-height: 170px;
  width: 100%;

  @include font-size(14px);

  .-large-text & {
    @include font-size(14px);

    font-family: $f-graphie-bold;
  }

  .-centered & {
    text-align: center;
  }

  /* .inscription & {
    width: 280px;
  } */
}
</style>
